import { Box, Stack } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { Typography } from "../../../muiStyled/DataDisplay/typographie"
import { Icon } from "../../../muiStyled/DataDisplay/Icons"
import { Tooltip } from "../../../muiStyled/DataDisplay/tooltip"
import { DescriptionsProps, SingleLineTypography } from "."

type ImsDescriptionProps = DescriptionsProps & {
    additionalDescription: string
}

export function ImsDescription({ additionalDescription, oneLine, hideImsIcons }: ImsDescriptionProps) {
    const { translateText } = useLocalization()

    if (oneLine) {
        if (hideImsIcons) {
            return (
                <Tooltip
                    title={
                        <Stack gap={1}>
                            <Box sx={{ textDecoration: "underline" }}>{translateText(14127)}</Box>
                            <div>{additionalDescription}</div>
                        </Stack>
                    }
                >
                    <SingleLineTypography variant="body2">{additionalDescription}</SingleLineTypography>
                </Tooltip>
            )
        }
        return (
            <Stack direction="row" gap={0.5}>
                <Icon name="plus" />
                <SingleLineTypography variant="body2">{additionalDescription}</SingleLineTypography>
            </Stack>
        )
    }
    if (hideImsIcons) {
        return (
            <Tooltip
                title={
                    <div>
                        <div>{translateText(912)}</div>
                        <div>{additionalDescription}</div>
                    </div>
                }
            >
                <Typography variant="body2">{additionalDescription}</Typography>
            </Tooltip>
        )
    }
    return (
        <Stack direction="row" gap={0.5}>
            <Icon name="plus" />
            <Typography variant="body2">{additionalDescription}</Typography>
        </Stack>
    )
}
